export const PHASE_COLORS = {
    oil: "#0b8511", // green
    gas: "#ab110c", // red
    water: "#0c24ab", // blue
};

export const FLOW_COLORS = {
    oil_production: PHASE_COLORS.oil, // green
    gas_production: PHASE_COLORS.gas, // red
    water_production: PHASE_COLORS.water, // blue
    gas_injection: "#ff07a0", // pink
    water_injection: "#08dbff", // cyan
};
